// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
// See https://jira.tamg.io/browse/WP-2462
import useBlockScroll from './useBlockScroll';

type Props = {|
  /** The iOS bug fix will change the entire document which may not interact nicely with other components.
   * If defined, it will delay the bug fix (in milliseconds). Useful for page transition animations or anything relying on the computed styling immediately after a modal opens
   * */
  deferBugFix?: number,
  /** A callback once the BlockScroll has been fully applied */
  callback?: () => void,

  /** iOS 11 has a bug where the background (body) will scroll when scrolling overlays, and overflow:hidden
   * will not suffice. */
  iOS11BugFix?: boolean,
|};

const convertPropsToHookArg = ({ deferBugFix, callback, iOS11BugFix }: Props) => {
  if (iOS11BugFix === false) {
    return false;
  }
  if (deferBugFix !== undefined) {
    if (!callback) {
      return deferBugFix;
    }
    return [deferBugFix, callback];
  }
  return iOS11BugFix;
};

/** Prefer to use the useBlockScroll hook instead
 * A component that prevents scrolling in the body. Useful for modals, if nothing else.
 * Scrolling will be blocked on the body as long as 1 or more BlockScroll components are mounted
 */
const BlockScroll = (props: Props) => {
  useBlockScroll(true, convertPropsToHookArg(props));
  return null;
};

export default BlockScroll;
